<script setup lang="ts">
const props = defineProps<{
  resourceId: number
  resourceType: ResourceType
  vertical?: boolean
}>()
const $toast = useToast()

const { data: userInfo } = useAuth()
const { data, refresh } = useAsyncData(
  `favoriteState:${props.resourceType}:${props.resourceId}`,
  () => fetchFavStatus(props.resourceId, props.resourceType)
)

async function handleClick() {
  if (!userInfo.value.login) {
    useEmitter().emit('requestLogin')
    return
  }
  useEmitter().emit('openFavoriteForm', {
    resourceId: props.resourceId,
    resourceType: props.resourceType
  })
}

onMounted(() => {
  useEmitter().on(
    'favoriteSuccess',
    ({ resourceId, resourceType, isFavorite }) => {
      if (
        resourceId === props.resourceId &&
        resourceType === props.resourceType
      ) {
        refresh()
      }
    }
  )
})
</script>

<template>
  <m-icon
    class="m-favorite-action"
    :class="{ active: data?.isFavorite }"
    icon="lucide-star"
    :vertical="vertical"
    @click="handleClick"
  >
    <slot />
  </m-icon>
</template>

<style lang="scss" scoped>
.m-favorite-action {
  cursor: pointer;
  width: 100%;
  height: 100%;
  &.active {
    color: var(--color-yellow-500);
  }
}
</style>
